import React, { useState, useEffect, Fragment, useContext } from "react";
import localization from "assets/localization/localization";
import DivLayout from "components/sales/divLayout/divLayout";
import DocumentView from "../../../../../components/sales/downloadDocView/documentView";
import Layout from "../../../../../components/sales/layout/layout";
import { toast } from "react-toastify";
import FormSection from "../../../../../components/sales/formSection/formSection";
import s from "../../../../../components/sales/paymentPortal/addPayment/addPayment.module.css";
import DropDownInput from "../../../../../components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "../../../../../components/sales/Input/constantInput/constantInput";
import { Button } from "react-bootstrap";
import ModalPop from "../../../../../components/sales/modal/modal";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DatePicker from 'components/sales/datePicker/datePicker';
import FileUpload from "components/sales/fileUpload/fileUpload";

const B2CViewDetails = ({
    caseByIdRequest,
    match,
    caseByIdResponse = [],
    caseStatusUpdateRequest,
    caseStatusUpdateResponse = [],
    loanApplicationByIdRequest,
    loanApplicationByIdResponse = [],
    loanAccountRequest,
    loanAccountResponse = [],
    documentUploadUrlPublic,
    documentUrlDataPublic = [],
    loanApprovalRequestRequest,
    loanApprovalRequestResponse = [],
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState("");
    const [changeCarLoanStatusModalOpen, setChangeCarLoanStatusModalOpen] =
        useState(false);
    const [statusChangeInput, setStatusChangeInput] = useState({
        status: "",
        remark: "",
        id: "",
    });
    const [markAsDisbursedModal, setMarkAsDisbursedModal] = useState(false);
    const [disbursalData, setDisbursalData] = useState({
        disbursal_date: "",
        disbursal_memo: "",
        disbursal_remark: ""
    });
    const [roleId, setRoleId] = useState();
    const [userId, setUserId] = useState();
    const [remark, setRemark] = useState();
    const { baseUrl } = useContext(BaseUrl);
    const [paymentReleaseModal, setPaymentReleaseModal] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        (async () => {
            setUserId(JSON.parse(window.localStorage.loginDetails)?.id);
            setRoleId(window.localStorage.getItem("fusion-role"));
            await caseByIdRequest(match?.params?.id);
            await loanApplicationByIdRequest(match?.params?.id);
            await loanAccountRequest(match?.params?.id);
        })();
        setIsLoading(false);
    }, []);

    const submitStatus = async () => {
        statusChangeInput["id"] = match?.params?.id;

        if (!statusChangeInput?.remark && statusChangeInput?.status === 8) {
            toast.error("Remark is required");
            return false;
        } else if (
            !statusChangeInput?.remark &&
            (statusChangeInput?.status === 3 || statusChangeInput?.status === 10)
        ) {
            toast.error("Remark is required");
            return false;
        }
        setChangeCarLoanStatusModalOpen(false);
        setIsLoading(true);
        await caseStatusUpdateRequest(statusChangeInput);
        setIsLoading(false);
    };

    useEffect(() => {
        if (parseInt(caseStatusUpdateResponse?.status) === 200) {
            toast.success(caseStatusUpdateResponse?.message);
            setChangeCarLoanStatusModalOpen(false);
            setTimeout(() => {
                window.location.href = `${baseUrl}/ucd/lead/logged-in`
            }, 1000);
        } else if (caseStatusUpdateResponse?.status !== 200) {
            toast.error(caseStatusUpdateResponse?.message);
        }
    }, [caseStatusUpdateResponse]);

    const headerBtns = () => {
        return (
            <Fragment>
                {loanApplicationByIdResponse?.data?.status &&
                loanApplicationByIdResponse?.data?.status == "LOGGED_IN" && (
                    <Button
                        onClick={() => {
                            setChangeCarLoanStatusModalOpen(true);
                        }}
                        className="filter-hamburger btn btn-transparent btn-sm"
                    >
                        {"Change Status"}
                    </Button>
                )}
                {(loanApplicationByIdResponse?.data?.status &&
                loanApplicationByIdResponse?.data?.status == "APPROVED" && loanApplicationByIdResponse?.data?.case_category == "CAT_B") && (
                    <Button
                        onClick={() => {
                            setMarkAsDisbursedModal(true);
                        }}
                        className="filter-hamburger btn btn-transparent btn-sm"
                    >
                        {"Mark as disbursed"}
                    </Button>
                )}
                {(loanApplicationByIdResponse?.data?.status &&
                loanApplicationByIdResponse?.data?.status == "PAYMENT_DETAILS_ADDED" &&
                loanApplicationByIdResponse?.data?.case_category == "CAT_A") && (
                    <Button
                        onClick={() => {
                            setPaymentReleaseModal(true);
                        }}
                        className="filter-hamburger btn btn-transparent btn-sm"
                    >
                        {"Change Status"}
                    </Button>
                )}
            </Fragment>
        );
    };

    const handleDisbursalModalClose = () => {
        setMarkAsDisbursedModal(false);
        setDisbursalData((prev) => ({
            ...prev,
            disbursal_date: "",
            disbursal_memo: "",
            disbursal_remark: ""
        }));
    }

    const handlePaymentReleaseModalClose = () => {
        setPaymentReleaseModal(false);
    }

    const handleMarkAsDisbursed = async () => {
        if (disbursalData.disbursal_date == null || disbursalData.disbursal_date == "") {
            toast.error("Please select the disbursal date.")
        }
        if (disbursalData.disbursal_memo == null || disbursalData.disbursal_memo == "") {
            toast.error("Please upload the disbursal memo.")
        }
        const payload = {
            "id": match?.params?.id,
            "status": "COMPLETE_PAYMENT_RELEASED",
            "disbursal_date": disbursalData?.disbursal_date,
            "disbursal_memo": disbursalData?.disbursal_memo,
            "remark": disbursalData?.disbursal_remark
        }
        setMarkAsDisbursedModal(false);
        setIsLoading(true)
        await caseStatusUpdateRequest(payload);
        setIsLoading(false);
    }

    const handlePaymentRelease = async () => {
        setPaymentReleaseModal(false)
        setIsLoading(true)
        await loanApprovalRequestRequest({ loan_id: match?.params?.id, status: "REQUEST_FOR_PAYMENT_RELEASE" })
        setIsLoading(false)
    }

    useEffect(() => {
        if (parseInt(loanApprovalRequestResponse?.status) === 200) {
            toast.success(loanApprovalRequestResponse?.message);
            setPaymentReleaseModal(false);
            setTimeout(() => {
                window.location.href = `${baseUrl}/ucd/lead/logged-in`
            }, 1000);
        } else if (loanApprovalRequestResponse?.status !== 200) {
            toast.error(loanApprovalRequestResponse?.message);
        }
    }, [loanApprovalRequestResponse]);

    return (
        <Layout
            title={localization.BacktoList}
            isGoback
            isLoading={isLoading}
            Buttons={
                parseInt(roleId) === 54 ||
                    parseInt(roleId) === 41 ||
                    parseInt(roleId) === 62
                    ? headerBtns
                    : ""
            }
        >
            <Fragment>
                {loanApplicationByIdResponse?.data && (
                    <>
                        <div className="panel-card">
                            <div className="panel-heading">Customer Details</div>
                            <div className="panel-body">
                                <div className="details-listing">
                                    {loanApplicationByIdResponse &&
                                        loanApplicationByIdResponse?.data &&
                                        loanApplicationByIdResponse?.data?.customer_details && (
                                            <>
                                                <div className="row">
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={"Customer First Name"}
                                                            data={
                                                                loanApplicationByIdResponse?.data?.customer_details?.customer_first_name
                                                                ?? localization.na
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={"Customer Last Name"}
                                                            data={
                                                                loanApplicationByIdResponse?.data?.customer_details?.customer_last_name
                                                                ?? localization.na
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={"Phone Number"}
                                                            data={
                                                                loanApplicationByIdResponse?.data?.customer_details?.phone_number
                                                                ?? localization.na
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={"Address"}
                                                            data={
                                                                loanApplicationByIdResponse?.data?.customer_details?.address
                                                                ?? localization.na
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={"City"}
                                                            data={
                                                                loanApplicationByIdResponse?.data?.customer_details?.city
                                                                ?? localization.na
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={"Pincode"}
                                                            data={
                                                                loanApplicationByIdResponse?.data?.customer_details?.pincode
                                                                ?? localization.na
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    {loanApplicationByIdResponse &&
                                        loanApplicationByIdResponse?.data &&
                                        loanApplicationByIdResponse?.data?.customer_type &&
                                        loanApplicationByIdResponse?.data?.customer_type ==
                                        "COMPANY" && (
                                            <>
                                                <div className="row">
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={"Company Name"}
                                                            data={
                                                                loanApplicationByIdResponse?.data?.primary
                                                                    ?.meta_data?.company_name
                                                                    ? loanApplicationByIdResponse?.data
                                                                        ?.primary?.meta_data?.company_name
                                                                    : localization.na
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={"Company Type"}
                                                            data={
                                                                loanApplicationByIdResponse?.data?.primary
                                                                    ?.meta_data?.company_type
                                                                    ? loanApplicationByIdResponse?.data
                                                                        ?.primary?.meta_data?.company_type
                                                                    : localization.na
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={"Co-applicant Relation"}
                                                            data={
                                                                loanApplicationByIdResponse?.data?.primary
                                                                    ?.meta_data?.co_applicant_relation
                                                                    ? loanApplicationByIdResponse?.data
                                                                        ?.primary?.meta_data
                                                                        ?.co_applicant_relation
                                                                    : localization.na
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={"GST Number"}
                                                            data={
                                                                loanApplicationByIdResponse?.data?.primary
                                                                    ?.meta_data?.gst_number
                                                                    ? loanApplicationByIdResponse?.data
                                                                        ?.primary?.meta_data?.gst_number
                                                                    : localization.na
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={"Established In"}
                                                            data={
                                                                loanApplicationByIdResponse?.data?.primary
                                                                    ?.meta_data?.established_in
                                                                    ? loanApplicationByIdResponse?.data
                                                                        ?.primary?.meta_data?.established_in
                                                                    : localization.na
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={"Email"}
                                                            data={
                                                                loanApplicationByIdResponse?.data?.primary
                                                                    ?.meta_data?.email
                                                                    ? loanApplicationByIdResponse?.data
                                                                        ?.primary?.meta_data?.email
                                                                    : localization.na
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={"Address"}
                                                            data={
                                                                loanApplicationByIdResponse?.data?.primary
                                                                    ?.meta_data?.address
                                                                    ? loanApplicationByIdResponse?.data
                                                                        ?.primary?.meta_data
                                                                        ?.address
                                                                    : localization.na
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={"Company Turnover"}
                                                            data={
                                                                loanApplicationByIdResponse?.data?.primary
                                                                    ?.meta_data?.company_turnover
                                                                    ? loanApplicationByIdResponse?.data
                                                                        ?.primary?.meta_data
                                                                        ?.company_turnover
                                                                    : localization.na
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                </div>
                            </div>
                        </div>

                        <div className="panel-card">
                            <div className="panel-heading">Vehicle Details</div>
                            <div className="panel-body">
                                <div className="details-listing">
                                    {loanApplicationByIdResponse?.data && (
                                        <>
                                            <div className="row">
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Vehicle Registration No"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.vehicle_details?.vehicle_registration_number
                                                            ?? localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Vehicle Brand"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.vehicle_details?.vehicle_brand
                                                            ?? localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Vehicle Model"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.vehicle_details?.vehicle_model
                                                            ?? localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Vehicle Registraton Date"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.vehicle_details?.vehicle_registration_date
                                                            ?? localization.na
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="panel-card">
                            <div className="panel-heading">Loan Details</div>
                            <div className="panel-body">
                                <div className="details-listing">
                                    {loanApplicationByIdResponse?.data && (
                                        <>
                                            <div className="row">
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Requested Loan Amount"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.loan_details?.loan_requested_amount
                                                            ?? localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Bank Name"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.loan_details?.bank_name
                                                            ?? localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Loan Tenure"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.loan_details?.loan_tenure
                                                            ?? localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Rate Of Interest"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.loan_details?.rate_of_interest
                                                            ?? localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Loan Type"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.loan_details?.loan_type
                                                            ?? localization.na
                                                        }
                                                    />
                                                </div>
                                                {loanApplicationByIdResponse?.data?.loan_details?.disbursal_date !== "" &&
                                                    loanApplicationByIdResponse?.data?.loan_details?.disbursal_date !== undefined &&
                                                    loanApplicationByIdResponse?.data?.loan_details?.disbursal_date !== null && (
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Disbursal Date"}
                                                                data={
                                                                    loanApplicationByIdResponse?.data?.loan_details?.disbursal_date
                                                                    ?? localization.na
                                                                }
                                                            />
                                                        </div>
                                                    )}

                                                {loanApplicationByIdResponse?.data?.loan_details?.disbursal_memo && (
                                                    <div className="col-6">
                                                        <DocumentView
                                                            attachment={loanApplicationByIdResponse?.data?.loan_details?.disbursal_memo}
                                                            title={"Disbursal Memo"}
                                                        />
                                                    </div>
                                                )}

                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="panel-card">
                            <div className="panel-heading">RC Details</div>
                            <div className="panel-body">
                                <div className="details-listing">
                                    {loanApplicationByIdResponse?.data && (
                                        <>
                                            <div className="row">
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Case Category"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.case_category
                                                            ?? localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Case Code By"}
                                                        data={
                                                            loanApplicationByIdResponse?.data?.case_code_by
                                                            ?? localization.na
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        {loanApplicationByIdResponse?.data?.case_category == "CAT_A" && (
                            <>
                                <div className="panel-card">
                                    <div className="panel-heading">Account Details</div>
                                    <div className="panel-body">
                                        <div className="details-listing">
                                            {loanAccountResponse?.PRIMARY && (
                                                <>
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Account Number"}
                                                                data={
                                                                    loanAccountResponse?.PRIMARY?.account_number
                                                                    ?? localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"IFSC Code"}
                                                                data={
                                                                    loanAccountResponse?.PRIMARY?.ifsc_code
                                                                    ?? localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Bank Name"}
                                                                data={
                                                                    loanAccountResponse?.PRIMARY?.bank_name
                                                                    ?? localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Branch Name"}
                                                                data={
                                                                    loanAccountResponse?.PRIMARY?.branch_name
                                                                    ?? localization.na
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
                <ModalPop
                    title={"Change Status"}
                    show={changeCarLoanStatusModalOpen}
                    handleModalHide={() => {
                        setChangeCarLoanStatusModalOpen(false);
                    }}
                >
                    <Fragment>
                        <FormSection>
                            <div className={s.root}>
                                <div className={s.root}>
                                    <div>
                                        <div className="col-sm-12 col-ms-12 ">
                                            {parseInt(roleId) === 54 &&
                                                (loanApplicationByIdResponse?.data?.status ==
                                                    "LOGGED_IN" ||
                                                    loanApplicationByIdResponse?.data?.status ==
                                                    "APPROVED" ||
                                                    loanApplicationByIdResponse?.data?.status ==
                                                    "REQUEST_FOR_CASE_APPROVAL") && (
                                                    <DropDownInput
                                                        label={"Status"}
                                                        data={[
                                                            { id: 2, name: "Approve" },
                                                            { id: 3, name: "Reject" },
                                                            { id: 10, name: "Cancelled" },
                                                            // { id: 8, name: "Back to Modification" },
                                                        ]}
                                                        value={""}
                                                        isStarRequired={true}
                                                        getIdValue={(val) => {
                                                            setStatusChangeInput({
                                                                ...statusChangeInput,
                                                                status: val.id,
                                                            });
                                                        }}
                                                        required={true}
                                                    />
                                                )}

                                            {parseInt(roleId) === 54 &&
                                                (loanApplicationByIdResponse?.data?.status ==
                                                    "REJECTED" ||
                                                    loanApplicationByIdResponse?.data?.status ==
                                                    "CANCELLED") && (
                                                    <DropDownInput
                                                        label={"Status"}
                                                        data={[{ id: 9, name: "Logged In" }]}
                                                        value={""}
                                                        isStarRequired={true}
                                                        getIdValue={(val) => {
                                                            setStatusChangeInput({
                                                                ...statusChangeInput,
                                                                status: val.id,
                                                            });
                                                        }}
                                                        required={true}
                                                    />
                                                )}

                                            {(parseInt(roleId) === 41 || parseInt(roleId) === 62) &&
                                                loanApplicationByIdResponse?.data?.status ==
                                                "LOGGED_IN" && (
                                                    <DropDownInput
                                                        label={"Status"}
                                                        data={[
                                                            { id: 11, name: "Approval Request" },
                                                            { id: 10, name: "Cancelled" },
                                                            { id: 1, name: "Reject" },
                                                        ]}
                                                        value={""}
                                                        isStarRequired={true}
                                                        getIdValue={(val) => {
                                                            setStatusChangeInput({
                                                                ...statusChangeInput,
                                                                status: val.id,
                                                            });
                                                        }}
                                                        required={true}
                                                    />
                                                )}
                                        </div>

                                        <div className="col-sm-12 col-ms-12 ">
                                            <ConstantInput
                                                label={localization.remark}
                                                type="text"
                                                value={""}
                                                required={true}
                                                className="my-custom-datepicker-component "
                                                handleChange={(val) =>
                                                    setStatusChangeInput({
                                                        ...statusChangeInput,
                                                        remark: val,
                                                    })
                                                }
                                            />
                                        </div>

                                        <br />
                                        <Button
                                            className="btn btn-success btn-sm"
                                            onClick={() => submitStatus()}
                                        >
                                            {"Final Submit"}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </FormSection>
                    </Fragment>
                </ModalPop>

                {/* mark as disbursed modal start*/}
                <ModalPop
                    title={"Mark as disbursed"}
                    show={markAsDisbursedModal}
                    handleModalHide={handleDisbursalModalClose}
                >
                    <Fragment>
                        <FormSection>
                            <div className="row">
                                <div className="col-md-4">
                                    <DatePicker
                                        handleChange={(val) =>
                                            setDisbursalData({
                                                ...disbursalData,
                                                disbursal_date: val,
                                            })
                                        }
                                        label={'Disbursal Date'}
                                        isStarRequired
                                        required
                                    />
                                </div>

                                <div className="col-md-4">
                                    <ConstantInput
                                        label={'Remark'}
                                        type="text"
                                        required
                                        isStarRequired={true}
                                        handleChange={(val) => {
                                            setDisbursalData({ ...disbursalData, disbursal_remark: val });
                                        }}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <FileUpload
                                        id={"addAttachment"}
                                        accept=".pdf,.png,.jpg,.jpeg,.doc"
                                        documentUploadUrl={documentUploadUrlPublic}
                                        documentUrlData={documentUrlDataPublic}
                                        isStarRequired
                                        required
                                        onChange={(val) =>
                                            setDisbursalData({
                                                ...disbursalData,
                                                disbursal_memo: val,
                                            })
                                        }
                                    >
                                        <span className="btn btn-transparent">
                                            {'Disbursal Memo'}
                                            <span style={{ color: "red" }}>*</span>
                                        </span>
                                    </FileUpload>
                                </div>
                            </div>
                            <Button
                                className="btn btn-primary btn-sm mt-4"
                                onClick={handleMarkAsDisbursed}
                                disabled={disbursalData?.disbursal_date == "" || disbursalData?.disbursal_date == null || disbursalData?.disbursal_memo == "" || disbursalData?.disbursal_memo == null}
                            >
                                {"Final Submit"}
                            </Button>
                        </FormSection>
                    </Fragment>
                </ModalPop>
                {/* mark as disbursed modal end*/}

                {/* payment release modal start */}
                <ModalPop
                    title={"Payment Release"}
                    show={paymentReleaseModal}
                    handleModalHide={handlePaymentReleaseModalClose}
                >
                    <Fragment>
                        <FormSection>
                            <div className="row">
                                <div className="col-md-12">
                                    <DropDownInput
                                        label={"Status"}
                                        data={[
                                            { id: "REQUEST_FOR_PAYMENT_RELEASE", name: "REQUEST_FOR_PAYMENT_RELEASE" }
                                        ]}
                                        value={""}
                                        isStarRequired={true}
                                        // getIdValue={(val) => {
                                        //     setStatusChangeInput({
                                        //         ...statusChangeInput,
                                        //         status: val.id,
                                        //     });
                                        // }}
                                        required={true}
                                    />
                                </div>
                            </div>
                            <Button
                                className="btn btn-primary btn-sm mt-4"
                                onClick={handlePaymentRelease}
                            >
                                {"Final Submit"}
                            </Button>
                        </FormSection>
                    </Fragment>
                </ModalPop>
                {/* payment release modal end */}
            </Fragment>
        </Layout>
    );
};

export default B2CViewDetails;
